export enum QuestionStatusEnum {
    // All = 1,  Do not exist anymore on the API
    NotSolved = 1,
    Solved = 2,
    Hits = 3,
    NotHits = 4
}
